export enum LeadsPopupDelay {
  NoTimeDelay = 'no-time-delay',
  AfterThirtySeconds = 'after-thirty-seconds',
  AfterOneMinute = 'after-one-minute',
}
